import { TAO_KOE } from './../libs';

class Markensuche {
	constructor( brandlistEl ) {
		this.brandlistEl = brandlistEl;
		this.formEl = this.brandlistEl.querySelector( 'form' );
		this.searchEl = this.brandlistEl.querySelector( 'input[type=search]' );

		// Disable submit.
		this.formEl.addEventListener( 'submit', ( ev ) => ev.preventDefault() );

		// Trigger search on input.
		this.searchEl.addEventListener( 'input', ( ev ) => this.search( ev.target.value ) );

		// Search once so we get the initial state correct.
		this.search( this.searchEl.value );
	}

	search( searchInput ) {
		const sectionEls = Array.from( this.brandlistEl.querySelectorAll( '.brandlist_section' ) );
		const navItemEls = Array.from( this.brandlistEl.querySelectorAll( '.en_anchornav__item' ) );
		const brandEls = Array.from( this.brandlistEl.querySelectorAll( '.mdl_brand' ) );

		if ( searchInput.length > 0 ) {
			// Filter brands according to search input.
			const search = new RegExp( searchInput, 'i' );
			brandEls.forEach( ( brandEl ) => {
				const isNoMatch = brandEl.innerText.match( search ) === null;
				brandEl.classList.toggle( 'en_is_no_match', isNoMatch );
			} );
		} else {
			// If the input is empty, simply display all Brands.
			brandEls.forEach( ( brandEl ) => {
				brandEl.classList.remove( 'en_is_no_match' );
			} );
		}

		// Check all sections and hide those, that do not have visible brands.
		sectionEls.forEach( ( sectionEl ) => {
			const hasMatch = sectionEl.querySelector( '.mdl_brand:not(.en_is_no_match)' );
			sectionEl.classList.toggle( 'en_has_no_match', ! hasMatch );

			const activeNavEls = navItemEls.filter( ( navItemEl ) => navItemEl.dataset.enAnchornavId === sectionEl.dataset.enAnchornavId );
			activeNavEls.forEach( ( navItemEl ) => navItemEl.classList.toggle( 'en_has_no_match', ! hasMatch ) );
		} );
	}
}

const initMarkensuche = ( scopeEl = document ) => {
	const brandlistEls = scopeEl.querySelectorAll( '.mdl_brandlist' );
	brandlistEls.forEach( ( brandlistEl ) => {
		brandlistEl.KOE_BRAND_SEARCH ??= new Markensuche( brandlistEl );
	} );
};

// Init.
TAO_KOE.ready( 'markenfilter.js', () => initMarkensuche() );

// Expose.
TAO_KOE.Markensuche = Markensuche;

export {
	Markensuche as default,
	initMarkensuche,
};
